import { Link } from 'react-router-dom';

// Now only the 404. Every real route has a real screen.
export default function Placeholder({ title, note }) {
  return (
    <>
      <section className="hero">
        <h1 className="hero__title">{title}</h1>
        <p className="hero__sub">{note}</p>
      </section>
      <div className="inline">
        <Link to="/" className="btn btn--primary">Back to the start</Link>
        <Link to="/new" className="btn btn--quiet">Raise a request</Link>
      </div>
    </>
  );
}
